import React from "react";
import { motion } from "framer-motion";
import { Layers, ArrowRight, CheckCircle2 } from "lucide-react";

const SoftwareConsolidationSlide = () => {
  return (
    <div className="h-full w-full bg-slate-100 flex flex-col items-center justify-center p-12 relative overflow-hidden font-sans">
      {/* Background */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-blue-100/50 rounded-full blur-[80px] -translate-y-1/2 translate-x-1/2" />
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-indigo-100/50 rounded-full blur-[80px] translate-y-1/2 -translate-x-1/2" />

      <div className="max-w-[1200px] w-full relative z-10 flex flex-col items-center justify-center h-full text-center">
        
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="mb-8"
        >
          <div className="w-20 h-20 rounded-2xl bg-blue-600 flex items-center justify-center mx-auto shadow-xl mb-6">
            <Layers className="w-10 h-10 text-white" />
          </div>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="text-5xl md:text-6xl lg:text-7xl font-bold text-slate-900 mb-8 leading-tight tracking-tight"
        >
          Asha's <span className="text-blue-600">software</span> replaces
          <br />
          your <span className="text-blue-600">10+ different softwares</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.35 }}
          className="text-xl md:text-2xl text-slate-500 font-medium max-w-3xl mb-10 leading-relaxed"
        >
          PMS, imaging, communications, marketing, eClaims, payments, verification — all unified in one platform instead of 10 separate vendors.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.5 }}
          className="bg-white rounded-2xl p-8 shadow-lg border border-slate-200 max-w-3xl"
        >
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="text-6xl font-black text-slate-300">10+</div>
            <ArrowRight className="w-12 h-12 text-slate-400" />
            <div className="text-6xl font-black text-blue-600">1</div>
          </div>

          <p className="text-2xl text-slate-700 font-semibold leading-relaxed">
            One platform. One login. Everything unified.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.8 }}
          className="flex items-center gap-3 mt-8 bg-blue-50 border border-blue-100 rounded-full px-6 py-3"
        >
          <span className="text-base text-blue-700 font-semibold">
            Up next: how Asha's <span className="font-extrabold">AI</span> handles the work your <span className="font-extrabold">staff</span> does
          </span>
          <ArrowRight className="w-5 h-5 text-blue-500" />
        </motion.div>
      </div>
    </div>
  );
};

export default SoftwareConsolidationSlide;
